import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export { Loading }

const logo = '/images/capo-logo.svg'

const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Capo Logo"
        sx={{
          height: 100,
          width: 100,
          animation: 'spin 1.6s ease-in-out infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        }}
      />

      <Typography
        variant="h2"
        sx={{ marginLeft: 0, marginRight: 0, marginBottom: 0 }}
      >
        Welkom bij CAPO
      </Typography>
    </Box>
  )
}
